import { createReducer } from '@reduxjs/toolkit'

import type { TCompanyDto } from '@homepal/api-contract'

import { insertItems } from 'redux/utils'

import * as actions from '../../actions/Companies/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type CompanyBody = {
  [key: string]: TCompanyDto
}

export interface CompanyReducerType {
  data: CompanyBody
  fetched: boolean
}

// Initial state
const INITIAL_STATE: CompanyReducerType = {
  data: {},
  fetched: false
}

// Reducer (createReducer uses immer — cases mutate the draft directly)
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload.data)
      state.fetched = true
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
